import type { PolicyBuildingsQueryInputs } from "../ts-types/mapsTypes";

export const getPolicyBuildingsCacheArgs = ({ accessToken, ...params }: PolicyBuildingsQueryInputs) => ({
  ...params,
  // Unknown identities stay token-scoped instead of sharing cached data.
  authScope: params.authScope || accessToken,
});
